import React, { FC } from 'react';

const IconPercentageArrowDown: FC = () => {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 7L10 0H0L5 7Z" fill="#FF173A" />
    </svg>
  );
};

export default IconPercentageArrowDown;
